<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <service-basics
            v-if='item'
            :item='item'
            @update='update'
          ></service-basics>
        </v-col>
        <v-col cols='12' md='4'>
          <service-details 
            v-if='item'
            :item='item'
            @update='update'
          ></service-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  // borrowing the inventory basics and details forms for now since they're identical for the moment.  May need to create their own at a future date.
import Basics from '../../inventory/detail/Basics'
import Details from '../../inventory/detail/Details'

export default {
  name: 'service-detail-overview',
  props: {
    item: {
      required: true
    }
  },
  components: {
    'service-basics': Basics,
    'service-details': Details
  },
  methods: {
    update (item) {
      this.$emit('update', item)
    },
  }
}
</script>
